import { isFunction } from "lodash";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { downloadMontlyStatementsApi, logEvent } from "../api";
import { SHOW_MESSAGE } from "./actionTypes";
import moment from "moment";
import { isIOS, isMobile } from "react-device-detect";
import { ACTIVITY_DETAIL, EVENTS } from "../../utils/events";

export const downloadMontlyStatements = (payload, onSuccess, onFailure) => async (dispatch) => {
    try {
        const response = await downloadMontlyStatementsApi(payload);
        const filename = `Payout-Statement_${moment().format('DD_MM_YYYY_HH:MM')}.${payload.type}`;
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        if (isIOS && isMobile) {
           const win = window.open(url, "_blank");
           if (!win) {
            alert(`Popup blocked. Please allow popups for this website.`)
            logEvent({
                current: EVENTS.STATEMENTS.STATEMENT_DOWNLOAD_ERROR,
                activity: ACTIVITY_DETAIL.STATEMENTS.STATEMENT_DOWNLOAD_ERROR,
                meta: {
                  data: {
                    ...payload,
                  }
                }
              });
            isFunction(onFailure) && onFailure();
           } else {
            isFunction(onSuccess) && onSuccess();
           }
        } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            isFunction(onSuccess) && onSuccess();
        }

    } catch (err) {
        isFunction(onFailure) && onFailure();
        dispatch({
            type: SHOW_MESSAGE,
            payload: {
                type: MESSAGE_BAR_TYPES.ERROR,
                message: err?.response?.data?.message || err.message,
            },
        });
    }
}
